import { render, staticRenderFns } from "./tableGutters.vue?vue&type=template&id=d3e6bbe0&scoped=true"
import script from "./tableGutters.vue?vue&type=script&lang=js"
export * from "./tableGutters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e6bbe0",
  null
  
)

export default component.exports